import Card, { SUIT } from "./card";
import Chair from "./chair";
import Contract, { PENALTY } from "./contract";

export class ContractResult {
	contract = new Contract();
    declarer = new Chair().setNorth();
    tricks = 0;
    score = 0;
    scoreNS = 0;
    isVulnerable = false;
    lead = new Card();

	static calculateScore(contract : Contract, totalTricks: number, isVulnerable: boolean) {
		let score = 0;
		let penaltyMultiplier = 0;
		let partScorePenaltyMultiplier = 0;

		let partScore = 0;

		switch (contract.penalty) {
		case PENALTY.NONE:
			penaltyMultiplier = 0;
			break;
		case PENALTY.DOUBLE:
			penaltyMultiplier = 1;
			break;
		case PENALTY.REDOUBLE:
			penaltyMultiplier = 2;
			break;
		}

		const vulnerabilityMultiplier = isVulnerable ? 1 : 0;
		const normalizedTricks = totalTricks - 6;
		const overtricks = normalizedTricks - contract.height;

		if (overtricks < 0) { 
            // negative overtricks, so contract is down
			// calculate base score for a downtrick (50 non-vul; 100 vul)
			const baseDownPoints = isVulnerable ? 100 : 50;

			// calculate down score
			score = overtricks * baseDownPoints;

			if (contract.penalty != PENALTY.NONE) {
				score *= (4 - vulnerabilityMultiplier) * penaltyMultiplier;
				score += 100 * penaltyMultiplier;
			}

			// add bonus for 4th and each next down trick if not vulnerable
			// (x = +100; xx = +200)
			if (!isVulnerable && overtricks < -3) {
				score += 100 * penaltyMultiplier * (overtricks + 3);
			}
		}
		else
		{
			switch(contract.penalty) {
			case PENALTY.NONE:
				partScorePenaltyMultiplier = 1;
				break;
			case PENALTY.DOUBLE:
				partScorePenaltyMultiplier = 2;
				break;
			case PENALTY.REDOUBLE:
				partScorePenaltyMultiplier = 4;
			}

			// calculate partner score
			switch(contract.suit) {
			case SUIT.CLUBS:
			case SUIT.DIAMONDS:
				partScore = 20 * contract.height * partScorePenaltyMultiplier;
				break;
			case SUIT.HEARTS:
			case SUIT.SPADES:
				partScore = 30 * contract.height * partScorePenaltyMultiplier;
				break;
			case SUIT.NOTRUMP:
				partScore = 40 * partScorePenaltyMultiplier + 30 *
				(contract.height - 1) * partScorePenaltyMultiplier;
			}

			// If iPartScore >= 100 award game bonus, else award partscore bonus
			if (partScore >= 100)
				score = partScore + 300 + 200 * vulnerabilityMultiplier;
			else
				score = partScore + 50;

			// Always add 50 for a x-ed contract and 100 for a xx-ed contract
			score += 50 * penaltyMultiplier;

			// Add overtrick points
			if (overtricks > 0) {
				if (contract.penalty === PENALTY.NONE) {
					switch (contract.suit) {
					case SUIT.CLUBS:
					case SUIT.DIAMONDS:
						score += 20 * overtricks * partScorePenaltyMultiplier;
						break;
					case SUIT.HEARTS:
					case SUIT.SPADES:
					case SUIT.NOTRUMP:
						score += 30 * overtricks * partScorePenaltyMultiplier;
					}
				} else {
					score += 100 * penaltyMultiplier * overtricks *
							(vulnerabilityMultiplier + 1);
				}
			}

			// If iContractHeight 6 or 7, award slam bonus
			if (contract.height === 6) {
				score += 500 + 250 * vulnerabilityMultiplier;
			} else if (contract.height === 7) {
				score += 1000 + 500 * vulnerabilityMultiplier;
			}
		}
		return score;
	}
}